import { addLocaleData } from 'react-intl';
import pt from 'react-intl/locale-data/pt';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/pt';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(pt);



// WEBPACK FOOTER //
// ./src/js/locale-data/pt.js